import axios from "axios";
import { toast } from "sonner";
import { API } from "../shared/config";

export const NAV_MODES = [
  { id: 'jour', label: 'Mode jour', desc: 'Navigation classique, fond clair' },
  { id: 'nuit', label: 'Mode nuit', desc: 'Même navigation, habillage sombre futuriste' },
];
const VALID = NAV_MODES.map(m => m.id);
// Anciennes préférences enregistrées (ancienne / nouvelle / futuriste)
const LEGACY = { ancienne: 'jour', nouvelle: 'jour', futuriste: 'nuit' };
const clean = (v) => (VALID.includes(v) ? v : LEGACY[v] || null);

// Mode d'affichage : bascule de session > préférence utilisateur (serveur) > jour
export const getNavMode = (user) => clean(sessionStorage.getItem('NAV_SESSION')) || clean(user?.navigation) || 'jour';

// Bascule jour/nuit : appliquée tout de suite, mémorisée sur le compte
export const setNavMode = async (mode, user, setUser) => {
  sessionStorage.setItem('NAV_SESSION', mode);
  setUser?.({ ...user, navigation: mode });
  try {
    await axios.put(`${API}/users/me/navigation`, { navigation: mode });
  } catch {
    toast.error("Impossible d'enregistrer votre préférence d'affichage");
  }
};

export const clearNavSession = () => sessionStorage.removeItem('NAV_SESSION');
